import { gql } from '@apollo/client';

export const CampaignLeadSourceQuery = gql`
  query CampaignLeadSource($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      leadSource {
        expireAfterDays
        leadPostingStrategy
      }
    }
  }
`;
